import React from 'react'
import { Link } from 'gatsby'
import {
  Intro,
  Layout,
  ItemTitle,
  SectionTitle,
  Header,
} from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        category={data.category}
        changelog={changelog[data.title].changelog}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        updated={data.updated}
      >
        <Intro>
          <p>
            Use the colors classes to alter the color of font or background
            colors. Be sure to follow our{' '}
            <Link
              class="link"
              to={'/' + data.site + '/guidelines/color/design'}
            >
              color guidelines
            </Link>{' '}
            and use colors at sufficient contrast to meet accessibility
            standards. Predefined gradient and transparency styles are included
            here.
          </p>
        </Intro>

        <SectionTitle>Colors</SectionTitle>
        <p>
          These utilities control CSS properties related to color and background
          color.
        </p>
        <table>
          <thead>
            <th align="left" class="token-header">
              Token
            </th>
            <th align="left">Hex</th>
            <th align="left">Font Class</th>
            <th align="left">Background Class</th>
          </thead>
          <tbody>
            {data.colors.map(color => (
              <tr>
                <td>
                  <div class={`color-swatch u-bg--${color.class}`} />
                  {color.name}
                </td>
                <td>{color.hex}</td>
                <td>
                  <code class="table__code">.u-color--{color.class}</code>
                </td>
                <td>
                  <code class="table__code">.u-bg--{color.class}</code>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <SectionTitle className="l-margin-top--xxxlarge">
          Fill Variants
        </SectionTitle>
        <ItemTitle>Solid</ItemTitle>
        <p>Use for filling objects with a single, solid color.</p>
        <table class="table">
          <thead>
            <th> </th>
            <th>Hex</th>
          </thead>
          <tbody>
            <tr>
              <td width="350px">
                <span class="color-square u-bg--primary-base"></span> Green /
                Primary / Base
              </td>
              <td>#007856</td>
            </tr>
            <tr>
              <td>
                <span class="color-square u-bg--secondary"></span> Green /
                Secondary
              </td>
              <td>#EAF7EF</td>
            </tr>
            <tr>
              <td>
                <span class="color-square u-bg--gray-lighter"></span> Gray /
                Lighter
              </td>
              <td>#EFEFEF</td>
            </tr>
            <tr>
              <td>
                <span class="color-square u-bg--gray-darker"></span> Gray /
                Darker
              </td>
              <td>#333333</td>
            </tr>
            <tr>
              <td>
                <span class="color-square u-bg--white"></span> White
              </td>
              <td>#FFFFFF</td>
            </tr>
          </tbody>
        </table>

        <ItemTitle>Gradient</ItemTitle>
        <p>
          Use for filling objects with a predefined gradient between two colors.
        </p>

        <table class="table">
          <thead>
            <th> </th>
            <th>Start</th>
            <th>Finish</th>
            <th>Class</th>
          </thead>
          <tbody>
            <tr>
              <td width="350px">
                <span class="color-square u-bg--gradient-primary-base"></span>{' '}
                Green / Primary / Base
              </td>
              <td className="showcase-table__font-values" width="175px">
                color: <strong>#18864A</strong> <br />
                x, y: <strong>0%, 0%</strong>
              </td>
              <td className="showcase-table__font-values" width="175px">
                color: <strong>#007856</strong> <br />
                x, y: <strong>100%, 100%</strong>
              </td>
              <td>
                <span class="table__code">.u-bg--gradient-primary-base</span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="color-square u-bg--gradient-gray-lighter"></span>{' '}
                Gray / Light
              </td>
              <td className="showcase-table__font-values">
                color: <strong>#EFEFEF</strong> <br />
                x, y: <strong>0%, 0%</strong>
              </td>
              <td className="showcase-table__font-values">
                color: <strong>#D7D7D7</strong> <br />
                x, y: <strong>100%, 100%</strong>
              </td>
              <td>
                <span class="table__code">.u-bg--gradient-gray-lighter</span>
              </td>
            </tr>
          </tbody>
        </table>

        <ItemTitle>Transparent</ItemTitle>
        <p>
          Use for filling objects with a single color at a predefined opacity.
        </p>

        <table class="table">
          <thead>
            <th> </th>
            <th>Hex</th>
            <th>Opacity</th>
            <th>Class</th>
          </thead>
          <tbody>
            <tr>
              <td width="350px">
                <span class="color-square u-bg--transparent-primary-base-85"></span>
                Green / Primary / Base / 85%
              </td>
              <td width="175px">#007856</td>
              <td width="175px">85%</td>
              <td>
                <span class="table__code">
                  .u-bg--transparent-primary-base-85
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="color-square u-bg--transparent-black-15"></span>
                Black / 15%
              </td>
              <td> #000</td>
              <td> 15%</td>
              <td>
                <span class="table__code">.u-bg--transparent-black-15</span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="color-square u-bg--transparent-black-25"></span>
                Black / 25%
              </td>
              <td> #000</td>
              <td> 25%</td>
              <td>
                <span class="table__code">.u-bg--transparent-black-25</span>
              </td>
            </tr>
          </tbody>
        </table>

        <ItemTitle>None</ItemTitle>
        <p>Use for removing or customizing an existing fill.</p>
      </Layout>
    </>
  )
}

export const code = {
  flex: `<div class="u-flex-container"></div>
<div class="u-flex-align--left"></div>
<div class="u-flex-align--right"></div>
<div class="u-flex-align--center"></div>
<div class="u-flex-align--center-middle"></div>
<div class="u-flex-align--justify"></div>
<div class="u-flex-align--spaced"></div>
<div class="u-flex-align--top"></div>
<div class="u-flex-align--middle"></div>
<div class="u-flex-align--bottom"></div>
<div class="u-flex-align--stretch"></div>
<div class="u-flex-align-self--top"></div>
<div class="u-flex-align-self--middle"></div>
<div class="u-flex-align-self--bottom"></div>
<div class="u-flex-align-self--stretch"></div>
<div class="u-flex-child--auto"></div>
<div class="u-flex-child--grow"></div>
<div class="u-flex-child--shrink"></div>
<div class="u-flex-dir--row"></div>
<div class="u-flex-dir--row-reverse"></div>
<div class="u-flex-dir--column"></div>
<div class="u-flex-dir--column-reverse"></div>
`,
}
